import UIDs from "../../../../UIDs";

const uid = UIDs.screens.admin.setting;

const ActionTypes = {
    LOAD_SCREEN_VIEW_ASYNC: `${uid}.loadScreenViewAsync`,
    LOAD_SCREEN_VIEW_SUCCESS: `${uid}.loadScreenViewSuccess`,
    LOAD_SCREEN_VIEW_FAILURE: `${uid}.loadScreenViewFailure`,
    UPDATE_SETTING_ASYNC: `${uid}.updateSettingAsync`,
    UPDATE_SETTING_SUCCESS: `${uid}.updateSettingSuccess`,
    UPDATE_SETTING_FAILURE: `${uid}.updateSettingFailure`,
    RESET_DATA_ASYNC: `${uid}.resetDataAsync`,
    RESET_DATA_SUCCESS: `${uid}.resetDataSuccess`,
    RESET_DATA_FAILURE: `${uid}.resetDataFailure`,
    UPDATE_SCREEN_STATE: `${uid}.updateScreenState`,
    GET_SETTING_ASYNC: `${uid}.getSettingAsync`,
    GET_SETTING_SUCCESS: `${uid}.getSettingSuccess`,
    GET_SETTING_FAILURE: `${uid}.getSettingFailure`
};

export { ActionTypes };
